module.exports = __webpack_public_path__ + "static/Shehryar Assad.5c4f3c23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Shehryar Assad.jpg
// module id = 1235
// module chunks = 6166952557895